<template>
  <div v-show="visible" class="back-to-bottom" @click="scrollToBottom">
    <img src="@/assets/images/ai-chat/back-to-bottom.png" class="w-14" />
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";

const props = defineProps<{
  target?: null | HTMLElement;
}>();

const visible = ref(false);
let lastScrollTop = 0;
let hideTimer: ReturnType<typeof setTimeout> | null = null;

const checkScroll = () => {
  const el = props.target;
  if (!el) return;

  const scrollTop = el.scrollTop;
  const scrollHeight = el.scrollHeight;
  const clientHeight = el.clientHeight;
  const atBottom = scrollTop + clientHeight >= scrollHeight - 100;
  const isScrollingDown = scrollTop > lastScrollTop;
  const isScrollingUp = scrollTop < lastScrollTop;
  // 控制显示/隐藏
  if (atBottom || isScrollingUp) {
    // 向上滚或到底部 → 隐藏
    hide();
  } else if (isScrollingDown) {
    // 向下滚 → 显示并自动隐藏
    showTemporarily();
  }

  lastScrollTop = scrollTop;
};

// 显示并自动隐藏
const showTemporarily = () => {
  visible.value = true;

  if (hideTimer) clearTimeout(hideTimer);
  hideTimer = setTimeout(hide, 3000);
};

// 立即隐藏
const hide = () => {
  visible.value = false;
  if (hideTimer) clearTimeout(hideTimer);
};

defineExpose({
  checkScroll,
});

const scrollToBottom = () => {
  const el = props.target;
  if (!el) return;

  const scrollOptions: ScrollToOptions = {
    top: el.scrollHeight,
    behavior: "smooth",
  };

  el.scrollTo(scrollOptions);
  hide();
};

onMounted(() => {
  checkScroll();
  props.target?.addEventListener?.("touchmove", checkScroll);
});

onUnmounted(() => {
  props.target?.removeEventListener?.("touchmove", checkScroll);
});
</script>

<style scoped>
.back-to-bottom {
  @apply absolute bottom-30 left-0 right-0 mx-auto z-50 size-34 bg-white rounded-full flex items-center justify-center transition-all duration-300;

  box-shadow: 0px 2px 7px 0px rgba(184, 184, 184, 0.5);
  opacity: 0;
  transform: translateY(20px) scale(0.5);
  animation: fadeUp 0.3s ease-out forwards;
}

@keyframes fadeUp {
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
